import * as React from "react";
const SvgLeftDownIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", id: "memory-box-light-down-left", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 12H10V0H12V10H22V12Z" }));
export default SvgLeftDownIcon;
